export default __webpack_public_path__ + "static/media/india_flag.47789dd5.svg";